import {LovValueSummary} from '../../../../common/lov/lov-value/api/model/lovValueSummary.model';


export class PartnerTypeSummaryModel {
    type: LovValueSummary;
    main = false;
}
